<!-- <div [ngClass]="url ? url + 'Class': 'madhuri'">

</div> --><router-outlet></router-outlet>